import React, { useCallback, useEffect, useRef, useState } from "react";
import CommonNav from "../main/CommonNav";
import Footer from "../main/Footer";
import BuddibleSocket from "../lib/BuddibleSocket";
import Utilities from "../lib/Utilities";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();

let video_list = [];

export default function AdvertiseVideoCenter() {
  const { t, i18n } = useTranslation();
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const SEARCH_WORD = useRef();
  const vmCOMP_KIND_LIST = [
    { key: "Z01", title: t("videoCenter.kind.Z01") },
    { key: "Z02", title: t("videoCenter.kind.Z02") },
    { key: "Z03", title: t("videoCenter.kind.Z03") },
    { key: "Z04", title: t("videoCenter.kind.Z04") },
    { key: "other", title: t("videoCenter.kind.other") },
  ];

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
    requestVideoList();
  }, []);

  //검색 활성
  function actionSearch(vmCOMP_KIND) {
    let filter = {
      SEARCH_WORD: SEARCH_WORD.current.value,
    };
    if (vmCOMP_KIND !== undefined) {
      filter.vmCOMP_KIND = vmCOMP_KIND;
    }
    requestVideoList(filter);
  }

  //영상목록
  function requestVideoList(filter) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/advertise_video/JS_advertise_video_customer_select.php",
      msgID: msgID,
      data: {},
      ...filter,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          video_list = newData["returnData"];
          setIsNeedUpdate(!isNeedUpdate);
        }
      }
    });
  }

  const VideoItemRender = useCallback(({ item }) => {
    return <VideoItem {...item} />;
  }, []);

  const VideoItem = React.memo((props) => {
    const { vmLink, vmTitle, COMP_NM, COMP_LOGO, vmTopYN } = props;
    return (
      <div className="col-12 col-lg-4 m-0 p-0 px-2 mb-3 d-flex flex-row justify-content-center">
        <div className="w-100 position-relative">
          <div
            className="position-absolute w-100 h-100 cursor_pointer"
            style={{ zIndex: 1 }}
            onClick={() => {
              window.open(vmLink, "_blank", "width=1200,height=800");
            }}
          />

          {vmTopYN === "Y" && (
            <div
              className="position-absolute border rounded px-3 bg-white font-weight-bold"
              style={{ top: 5, right: 5, fontSize: "0.9em" }}
            >
              {t("videoCenter.pinned")}
            </div>
          )}
          <iframe
            className="rounded-lg border"
            width="100%"
            height="200"
            src={vmLink}
            title={vmTitle}
          />
          <div className="d-flex flex-row justify-content-start align-items-center mt-2">
            <div
              className="d-flex flex-row justify-content-center align-items-center rounded mr-2"
              style={{
                background: `url(${COMP_LOGO}) 50% 50% /contain no-repeat`,
                width: 50,
                height: 50,
              }}
            />
            <div className="text-secondary">
              <h6 className="mb-0 font-weight-bold">{vmTitle}</h6>
              <p>{COMP_NM}</p>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <div style={{ minHeight: "100vh", background: "#fefefe" }}>
      <CommonNav />
      <main style={{ marginTop: 56, background: "#fefefe" }}>
        <div className="container py-5">
          <div className="row m-0 p-0 mb-4">
            <div className="col-12 col-lg-8 m-0 p-0 px-2">
              <p className="h4 font-weight-900 text-freiscop">
                <i className="fa-brands fa-youtube mr-2 text-danger" />
                {t("videoCenter.title")}
              </p>
              <p className="h6 font-weight-bold">
                {t("videoCenter.description")}
              </p>
              <div className="rounded bg-freiscop-05 py-2 px-3 d-flex flex-row justify-content-between align-items-center font-weight-bold mb-2">
                <input
                  type="text"
                  className="border-0 bg-transparent flex-fill"
                  placeholder={t("videoCenter.search")}
                  ref={SEARCH_WORD}
                />
                <span className="cursor_pointer" onClick={() => actionSearch()}>
                  <i className="fa-solid fa-magnifying-glass" />
                </span>
              </div>
              <div className="d-flex flex-row flex-wrap">
                <div className="p-1">
                  <button
                    className="btn btn-sm btn-info font-weight-bold px-3"
                    onClick={() => {
                      SEARCH_WORD.current.value = "";
                      actionSearch("");
                    }}
                  >
                    {t("videoCenter.kind.all")}
                  </button>
                </div>
                {vmCOMP_KIND_LIST.map((item) => {
                  return (
                    <div className="p-1" key={item.key}>
                      <button
                        className="btn btn-sm btn-outline-info px-3 btn-hover-freiscop"
                        onClick={() => actionSearch(item.key)}
                      >
                        {t("videoCenter.kind." + item.key)}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="row m-0 p-0 ">
            {video_list.length > 0 ? (
              video_list.map((item, index) => {
                return <VideoItemRender key={item.vmIDX} item={item} />;
              })
            ) : (
              <div className="col-12 m-0 p-5 rounded-lg bg-light h6 text-secondary font-weight-bold text-center">
                {t("videoCenter.noData")}
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
